<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>
<script>
export default {
  data () {
   return {
     isRouterAlive: true
   }
 },
provide() {
	return {
       reload: this.reload  //this.reload方法注入 到reload参数中，从子组件获取
   }
},
 methods: {
   reload () {
     this.isRouterAlive = false;
     this.$nextTick(() => (this.isRouterAlive = true));
   }   
 },
  components: {},
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
}
</style>
